module.exports = require("isomorphic-vm");


//////////////////
// WEBPACK FOOTER
// external "isomorphic-vm"
// module id = 104
// module chunks = 0 1 2